/* eslint-disable react/prop-types */
import React from 'react';
import request from '@api';
import useConnectionContext from './useConnectionContext';

const SettingsContext = React.createContext();

export const SettingsProvider = ({ children }) => {
  const { merchantId } = useConnectionContext();
  const [settingsInfo, setSettingsInfo] = React.useState([]);
  const [settingsLoading, setSettingsLoading] = React.useState(true);

  const getSettings = React.useCallback(async () => {
    try {
      const { code, data } = await request('organization-settings');
      if (code === 0) {
        setSettingsInfo(data);
      }
    } catch (e) {
      console.log(e);
    }
    setSettingsLoading(false);
  });

  React.useEffect(() => {
    if (merchantId) {
      getSettings();
    }
  }, [merchantId]);

  const value = React.useMemo(
    () => ({
      settingsInfo, settingsLoading, getSettings,
    }),
    [settingsInfo, settingsLoading, getSettings],
  );

  return <SettingsContext.Provider value={value}>{children}</SettingsContext.Provider>;
};

const useSettings = () => React.useContext(SettingsContext);

export default useSettings;
